import React from "react";
import DoctorAppointments from "../DoctorAppointments/DoctorAppointments";
import useHospitalProviderRole from "./useHospitalProviderRole";

export default function HospitalAppointments() {
  useHospitalProviderRole();
  return <DoctorAppointments />;
}
